import {
  FACTOR_NAMES,
  type FactorCategory,
  type FactorDirection,
  type FactorName,
  type FactorObservation,
} from "../types/factor.ts";

export type FactorDefinition = {
  factorName: FactorName;
  label: string;
  category: FactorCategory;
  direction: FactorDirection;
};

export const FACTOR_REGISTRY: Record<FactorName, FactorDefinition> = {
  pe: { factorName: "pe", label: "市盈率", category: "value", direction: "lower_is_better" },
  ev_ebitda: { factorName: "ev_ebitda", label: "企业价值倍数", category: "value", direction: "lower_is_better" },
  fcf_yield: { factorName: "fcf_yield", label: "自由现金流收益率", category: "value", direction: "higher_is_better" },
  roe: { factorName: "roe", label: "净资产收益率", category: "quality", direction: "higher_is_better" },
  roic: { factorName: "roic", label: "投入资本回报率", category: "quality", direction: "higher_is_better" },
  operating_margin: { factorName: "operating_margin", label: "营业利润率", category: "quality", direction: "higher_is_better" },
  revenue_growth: { factorName: "revenue_growth", label: "营收增长率", category: "growth", direction: "higher_is_better" },
  eps_growth: { factorName: "eps_growth", label: "每股收益增长率", category: "growth", direction: "higher_is_better" },
  debt_equity: { factorName: "debt_equity", label: "负债权益比", category: "financialHealth", direction: "lower_is_better" },
  interest_coverage: { factorName: "interest_coverage", label: "利息保障倍数", category: "financialHealth", direction: "higher_is_better" },
  momentum_6m: { factorName: "momentum_6m", label: "六个月动量", category: "market", direction: "higher_is_better" },
  volatility: { factorName: "volatility", label: "年化波动率", category: "market", direction: "lower_is_better" },
};

export const FACTOR_DEFINITIONS = FACTOR_NAMES.map((factorName) => FACTOR_REGISTRY[factorName]);

export function isFactorName(value: string): value is FactorName {
  return Object.prototype.hasOwnProperty.call(FACTOR_REGISTRY, value);
}

export type FactorObservationInput = Omit<
  FactorObservation,
  "percentile" | "industryPercentile" | "category" | "direction"
> & {
  percentile?: number | null;
  industryPercentile?: number | null;
};

export function createFactorObservation(input: FactorObservationInput): FactorObservation {
  const definition = FACTOR_REGISTRY[input.factorName];
  const percentile = input.percentile ?? input.industryPercentile ?? null;
  return {
    ...input,
    percentile,
    industryPercentile: percentile,
    category: definition.category,
    direction: definition.direction,
  };
}
